import styled, { css, keyframes } from 'styled-components';
import { Colors, FlexBox } from '@brg/ui';
import { SCROLL_SELECT_ITEM_HEIGHT, SCROLL_SELECT_ITEM_HEIGHT_FAVORITE } from './config';
import { LayoutConst } from 'core';

export const Container = styled(FlexBox)<{customBg?: string, isFavoritesVersion?: boolean}>`
    align-items: flex-end;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding-left: 32px;
    padding-right: 32px;
    overflow-x: hidden;
    overflow-y: hidden;
    // margin-bottom: 100px;
    margin-bottom: 30px;
    z-index: 100;
    ${({customBg}) => customBg && css`
      background: ${customBg};
    `}
    ${({isFavoritesVersion})=> isFavoritesVersion && css`
      margin-bottom: 0;
      padding: 0;
    `}
`;

export const ChooserBox = styled(FlexBox)<{isFavoritesVersion?: boolean}>`
    width: 100vw;
    user-select: none;
    height: calc(100%);
    a {
      cursor: pointer;
      color: inherit;
    }
     ${({isFavoritesVersion})=> isFavoritesVersion && css`
      margin-bottom: 0;
      width: 100%;
      margin-top: -22vh;
    `}
`;

export const ChooserBoxMobile = styled(FlexBox)`
    width: 100vw;
    user-select: none;
`;

/**
 * Элемент выбора
 */
 export const ChooserNode = styled(FlexBox)<{isMobile?: boolean, justify?: string, isOnlines?: boolean, isTablet?: boolean, autoHeight?: boolean, isFavoritesVersion? : boolean }>`

  ${p => p?.isOnlines ? css`
      height: auto;
      margin-bottom: 10px;
  ` : null};
  ${({ autoHeight, isMobile, isFavoritesVersion }) => autoHeight ? css`
    height: auto;
    //margin-bottom: 16px;
  ` : css`
    height: ${isMobile ? "44px" : isFavoritesVersion ? `${SCROLL_SELECT_ITEM_HEIGHT_FAVORITE}px` :`${SCROLL_SELECT_ITEM_HEIGHT}px`};
  `};
  user-select: none;
  align-items: center;
  scroll-snap-align: center;
  width: ${p => p.isMobile ? `auto` : '50vw'};

  @media(max-width: ${LayoutConst.screen.m_1024}px) {
    ${p => p?.isOnlines ? null : css`
      width: auto;
    `};
  }

  justify-content: ${p => p.justify ? `${p.justify}` : 'flex-end'};
  cursor: pointer;
  @media only screen and (max-width: 1024px) and (min-width: 480px) {
      line-height: 40px;
    }
  &:nth-child(2) {
    margin-bottom: 200px;
  }
`;

// половина экрана
export const ChooserBoxPart = styled(FlexBox)<{scrl?: boolean, isFavoritesVersion?: boolean}>`
    height: calc(100vh);
    user-select: none;
    max-height: calc(100vh);
    width: 100%;
    overflow-y: ${p => p.scrl ? "auto" : "hidden"};
    position: relative;
    flex: 1;

    &::-webkit-scrollbar {
      display: ${p => p.scrl ? "block" : "none"};
      height: 1px;
      width: 1px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.app.backgroundColor};
      border-radius: 9em;
    }
    * {
        &::-webkit-scrollbar {
          // display: ${p => p.scrl ? "block" : "none"};
          display: none;
        }
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
    }

    div, a, span {
      @media(max-width: 743px) {
        font-size: 24px;
        line-height: 26px;
      }
      @media(max-width: 940px) {
        font-size: 50px;
        line-height: 56px;
        ${({isFavoritesVersion})=> isFavoritesVersion && css`
            font-family: Inter;
            font-size: 26px;
            font-style: normal;
            font-weight: 600;
            line-height: 32px;
            letter-spacing: -0.52px;
          `}
      }
        
    }
`;

/**
 * Анимация стрелки
 */
export const ArrowAnimation = keyframes`
  0% {
    transform: translateX(-10px);
    opacity: 0;
  }
  100% {

    transform: translateX(0);
    opacity: 1;
  }
`;

export const ChooserBoxPartMobile = styled(FlexBox)<{scrl?: boolean}>`
    user-select: none;
    width: 100%;
    overflow-y: ${p => p.scrl ? "auto" : "hidden"};
    position: relative;
    flex: 1;

    &::-webkit-scrollbar {
      display: ${p => p.scrl ? "block" : "none"};
      height: 1px;
      width: 1px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.app.backgroundColor};
      border-radius: 9em;
    }
    * {
        &::-webkit-scrollbar {
          display: ${p => p.scrl ? "block" : "none"};
        }
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
    }
`;
/**
 * Анимация точки
 */
export const PointAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {

    opacity: 1;
  }
`;

/**
 * Стрелка
 */
export const Arrow = styled(FlexBox)<{externalLink?: boolean}>`
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    font-size: 30px;
    padding-top: 6px;
    cursor: pointer;
    animation: ${ArrowAnimation} 0.4s linear forwards;
    ${({externalLink}) => externalLink && 'transform: rotate(-45deg)!important;'}
`;

/**
 * Контейнер выбора
 */
export const ChooserContainer = styled(FlexBox)<{isRussianGalllleryStyle?: boolean, isFavoritesVersion?: boolean}>`
    overflow-y: scroll;
    user-select: none;
    padding-top: calc(50vh - ${SCROLL_SELECT_ITEM_HEIGHT / 2}px);
    padding-bottom: calc(50vh - ${SCROLL_SELECT_ITEM_HEIGHT / 2}px);
    height: calc(100vh);
    max-height: calc(100vh);
    width: 100%;
    scroll-snap-type: y mandatory;
     scroll-behavior: smooth;
    box-sizing: border-box;
    border: none;
    ${({isFavoritesVersion})=> isFavoritesVersion && css`
          padding-top: calc(50vh - ${SCROLL_SELECT_ITEM_HEIGHT_FAVORITE / 2}px);
          padding-bottom: calc(50vh - ${SCROLL_SELECT_ITEM_HEIGHT_FAVORITE / 2}px);

      `}
    ${({isRussianGalllleryStyle}) => isRussianGalllleryStyle && 'background: #e7e7e7;'}
    div, a, span {
      @media(max-width: 743px) {
        font-size: 24px;
        line-height: 26px;
      }
      @media(max-width: 940px) {
        font-size: 50px;
        line-height: 56px;
         ${({isFavoritesVersion})=> isFavoritesVersion && css`
            font-family: Inter;
            font-size: 26px;
            font-style: normal;
            font-weight: 600;
            line-height: 32px;
            letter-spacing: -0.52px;
          `}
      }
    }
`;

// Тупо точка, которая появляется и исчезает
export const PrettyPoint = styled.div<{ visible: boolean }>`
    display: inline-block;
    opacity: ${(p) => (p.visible ? 1 : 0)};
    animation: ${(p) => (p.visible ? PointAnimation : null)} 0.4s linear forwards;
`;

/**
 * Рамки с прозрачностью
 */
export const ChooserOpacity = styled(FlexBox)<{isRussianGalllleryStyle?: boolean, disableOpacity?: boolean, isFavoritesVersion? : boolean, isTopChooserOpacity?: boolean}>`
    width: 100%;
    height: calc(50vh - ${SCROLL_SELECT_ITEM_HEIGHT / 2}px);
    ${({isFavoritesVersion})=> isFavoritesVersion && css`
          height: calc(50vh - ${SCROLL_SELECT_ITEM_HEIGHT_FAVORITE / 2}px);
          background: linear-gradient(to top, rgba(231, 231, 231, 0), rgba(231, 231, 231, 0.6) 12.39% , #E7E7E7) !important;
       
      `}
    ${({isFavoritesVersion,isTopChooserOpacity})=> isFavoritesVersion && isTopChooserOpacity && css`
          top: 18%;
          height: 250px;
          @media(max-width: '') {
  
          }
      `}
    top: ${({isFavoritesVersion})=> !isFavoritesVersion && 0};
    pointer-events: none;
    left: 0;
    right: 0;
    position: absolute;
    z-index: 1000;
    background: ${(p) => p.theme.selectContextModal.background};
    background: rgb(42, 48, 52);
    background: ${(p) => p.theme.selectContextModal.opacityTop};
    background: ${(p) => p.isRussianGalllleryStyle? 'linear-gradient(to top, rgba(231, 231, 231, 0), rgba(231, 231, 231, 0.6) 12.39%, rgba(231, 231, 231, 1))' : p.theme.selectContextModal.opacityTop};
    ${({ disableOpacity }) => disableOpacity && css`
      background: transparent;
    `}
`;

export const ChooserOpacityTopFavoriteMoadal = styled(ChooserOpacity)`
   top: 21vh;
  height: 100px;
   background: linear-gradient(to top, rgba(231, 231, 231, 0), rgba(231, 231, 231, 0.6) 12.39% , #E7E7E7) !important;

`;


/**
 * Рамка с прозрачностью для низа
 */
export const ChooserOpacityBottom = styled(ChooserOpacity)`
    top: auto;
    bottom: 0;
      ${({ isFavoritesVersion }) => isFavoritesVersion && css`
        background: linear-gradient(to bottom, rgba(231, 231, 231, 0), rgba(231, 231, 231, 0.6) 12.39%, #E7E7E7) !important;
    `}
    background: ${(p) => p.theme.selectContextModal.opacityBottom};
    background: ${(p) => p.isRussianGalllleryStyle? 'linear-gradient(to bottom, rgba(231, 231, 231, 0), rgba(231, 231, 231, 0.6) 12.39%, rgba(231, 231, 231, 1))' : p.theme.selectContextModal.opacityBottom};
    ${({ disableOpacity }) => disableOpacity && css`
      background: transparent;
    `}
    ${({isFavoritesVersion})=> isFavoritesVersion && css`
        /* bottom: -1px; */
      `}
`;



export const FavoriteTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  width: 100%;
  position: relative;
  z-index: 2000;
  background-color: ${Colors.galBlack10};
  padding: 16px 16px;
  `
export const FavoriteTitle = styled.div`
  font-family: Inter;
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px; 
    letter-spacing: -0.56px;
    color: #212121;
`
export const FavoriteSubTitle = styled.div`
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.26px;
  color: #212121;
`
export const FavoriteIconCotainer = styled.div`
  display: flex
`import styled, { css, keyframes } from 'styled-components';
import { Colors, FlexBox } from '@brg/ui';
import { SCROLL_SELECT_ITEM_HEIGHT, SCROLL_SELECT_ITEM_HEIGHT_FAVORITE } from './config';
import { LayoutConst } from 'core';

export const Container = styled(FlexBox)<{customBg?: string, isFavoritesVersion?: boolean}>`
    align-items: flex-end;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding-left: 32px;
    padding-right: 32px;
    overflow-x: hidden;
    overflow-y: hidden;
    // margin-bottom: 100px;
    margin-bottom: 30px;
    z-index: 100;
    ${({customBg}) => customBg && css`
      background: ${customBg};
    `}
    ${({isFavoritesVersion})=> isFavoritesVersion && css`
      margin-bottom: 0;
      padding: 0;
    `}
`;

export const ChooserBox = styled(FlexBox)<{isFavoritesVersion?: boolean}>`
    width: 100vw;
    user-select: none;
    height: calc(100%);
    a {
      cursor: pointer;
      color: inherit;
    }
     ${({isFavoritesVersion})=> isFavoritesVersion && css`
      margin-bottom: 0;
      width: 100%;
      margin-top: -22vh;
    `}
`;

export const ChooserBoxMobile = styled(FlexBox)`
    width: 100vw;
    user-select: none;
`;

/**
 * Элемент выбора
 */
 export const ChooserNode = styled(FlexBox)<{isMobile?: boolean, justify?: string, isOnlines?: boolean, isTablet?: boolean, autoHeight?: boolean, isFavoritesVersion? : boolean }>`

  ${p => p?.isOnlines ? css`
      height: auto;
      margin-bottom: 10px;
  ` : null};
  ${({ autoHeight, isMobile, isFavoritesVersion }) => autoHeight ? css`
    height: auto;
    //margin-bottom: 16px;
  ` : css`
    height: ${isMobile ? "44px" : isFavoritesVersion ? `${SCROLL_SELECT_ITEM_HEIGHT_FAVORITE}px` :`${SCROLL_SELECT_ITEM_HEIGHT}px`};
  `};
  user-select: none;
  align-items: center;
  scroll-snap-align: center;
  width: ${p => p.isMobile ? `auto` : '50vw'};

  @media(max-width: ${LayoutConst.screen.m_1024}px) {
    ${p => p?.isOnlines ? null : css`
      width: auto;
    `};
  }

  justify-content: ${p => p.justify ? `${p.justify}` : 'flex-end'};
  cursor: pointer;
  @media only screen and (max-width: 1024px) and (min-width: 480px) {
      line-height: 40px;
    }
  &:nth-child(2) {
    margin-bottom: 200px;
  }
`;

// половина экрана
export const ChooserBoxPart = styled(FlexBox)<{scrl?: boolean, isFavoritesVersion?: boolean}>`
    height: calc(100vh);
    user-select: none;
    max-height: calc(100vh);
    width: 100%;
    overflow-y: ${p => p.scrl ? "auto" : "hidden"};
    position: relative;
    flex: 1;

    &::-webkit-scrollbar {
      display: ${p => p.scrl ? "block" : "none"};
      height: 1px;
      width: 1px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.app.backgroundColor};
      border-radius: 9em;
    }
    * {
        &::-webkit-scrollbar {
          // display: ${p => p.scrl ? "block" : "none"};
          display: none;
        }
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
    }

    div, a, span {
      @media(max-width: 743px) {
        font-size: 24px;
        line-height: 26px;
      }
      @media(max-width: 940px) {
        font-size: 50px;
        line-height: 56px;
        ${({isFavoritesVersion})=> isFavoritesVersion && css`
            font-family: Inter;
            font-size: 26px;
            font-style: normal;
            font-weight: 600;
            line-height: 32px;
            letter-spacing: -0.52px;
          `}
      }
        
    }
`;

/**
 * Анимация стрелки
 */
export const ArrowAnimation = keyframes`
  0% {
    transform: translateX(-10px);
    opacity: 0;
  }
  100% {

    transform: translateX(0);
    opacity: 1;
  }
`;

export const ChooserBoxPartMobile = styled(FlexBox)<{scrl?: boolean}>`
    user-select: none;
    width: 100%;
    overflow-y: ${p => p.scrl ? "auto" : "hidden"};
    position: relative;
    flex: 1;

    &::-webkit-scrollbar {
      display: ${p => p.scrl ? "block" : "none"};
      height: 1px;
      width: 1px;
    }
    ::-webkit-scrollbar-thumb {
      background-color: ${({ theme }) => theme.app.backgroundColor};
      border-radius: 9em;
    }
    * {
        &::-webkit-scrollbar {
          display: ${p => p.scrl ? "block" : "none"};
        }
        -ms-overflow-style: none; /* IE and Edge */
        scrollbar-width: none; /* Firefox */
    }
`;
/**
 * Анимация точки
 */
export const PointAnimation = keyframes`
  0% {
    opacity: 0;
  }
  100% {

    opacity: 1;
  }
`;

/**
 * Стрелка
 */
export const Arrow = styled(FlexBox)<{externalLink?: boolean}>`
    justify-content: center;
    align-items: center;
    border-radius: 50%;
    width: 40px;
    height: 40px;
    font-size: 30px;
    padding-top: 6px;
    cursor: pointer;
    animation: ${ArrowAnimation} 0.4s linear forwards;
    ${({externalLink}) => externalLink && 'transform: rotate(-45deg)!important;'}
`;

/**
 * Контейнер выбора
 */
export const ChooserContainer = styled(FlexBox)<{isRussianGalllleryStyle?: boolean, isFavoritesVersion?: boolean}>`
    overflow-y: scroll;
    user-select: none;
    padding-top: calc(50vh - ${SCROLL_SELECT_ITEM_HEIGHT / 2}px);
    padding-bottom: calc(50vh - ${SCROLL_SELECT_ITEM_HEIGHT / 2}px);
    height: calc(100vh);
    max-height: calc(100vh);
    width: 100%;
    scroll-snap-type: y mandatory;
     scroll-behavior: smooth;
    box-sizing: border-box;
    border: none;
    ${({isFavoritesVersion})=> isFavoritesVersion && css`
          padding-top: calc(50vh - ${SCROLL_SELECT_ITEM_HEIGHT_FAVORITE / 2}px);
          padding-bottom: calc(50vh - ${SCROLL_SELECT_ITEM_HEIGHT_FAVORITE / 2}px);

      `}
    ${({isRussianGalllleryStyle}) => isRussianGalllleryStyle && 'background: #e7e7e7;'}
    div, a, span {
      @media(max-width: 743px) {
        font-size: 24px;
        line-height: 26px;
      }
      @media(max-width: 940px) {
        font-size: 50px;
        line-height: 56px;
         ${({isFavoritesVersion})=> isFavoritesVersion && css`
            font-family: Inter;
            font-size: 26px;
            font-style: normal;
            font-weight: 600;
            line-height: 32px;
            letter-spacing: -0.52px;
          `}
      }
    }
`;

// Тупо точка, которая появляется и исчезает
export const PrettyPoint = styled.div<{ visible: boolean }>`
    display: inline-block;
    opacity: ${(p) => (p.visible ? 1 : 0)};
    animation: ${(p) => (p.visible ? PointAnimation : null)} 0.4s linear forwards;
`;

/**
 * Рамки с прозрачностью
 */
export const ChooserOpacity = styled(FlexBox)<{isRussianGalllleryStyle?: boolean, disableOpacity?: boolean, isFavoritesVersion? : boolean, isTopChooserOpacity?: boolean}>`
    width: 100%;
    height: calc(50vh - ${SCROLL_SELECT_ITEM_HEIGHT / 2}px);
    ${({isFavoritesVersion})=> isFavoritesVersion && css`
          height: calc(50vh - ${SCROLL_SELECT_ITEM_HEIGHT_FAVORITE / 2}px);
          background: linear-gradient(to top, rgba(231, 231, 231, 0), rgba(231, 231, 231, 0.6) 12.39% , #E7E7E7) !important;
       
      `}
    ${({isFavoritesVersion,isTopChooserOpacity})=> isFavoritesVersion && isTopChooserOpacity && css`
          top: 18%;
          height: 250px;
          @media(max-width: '') {
  
          }
      `}
    top: ${({isFavoritesVersion})=> !isFavoritesVersion && 0};
    pointer-events: none;
    left: 0;
    right: 0;
    position: absolute;
    z-index: 1000;
    background: ${(p) => p.theme.selectContextModal.background};
    background: rgb(42, 48, 52);
    background: ${(p) => p.theme.selectContextModal.opacityTop};
    background: ${(p) => p.isRussianGalllleryStyle? 'linear-gradient(to top, rgba(231, 231, 231, 0), rgba(231, 231, 231, 0.6) 12.39%, rgba(231, 231, 231, 1))' : p.theme.selectContextModal.opacityTop};
    ${({ disableOpacity }) => disableOpacity && css`
      background: transparent;
    `}
`;

export const ChooserOpacityTopFavoriteMoadal = styled(ChooserOpacity)`
   top: 21vh;
  height: 100px;
   background: linear-gradient(to top, rgba(231, 231, 231, 0), rgba(231, 231, 231, 0.6) 12.39% , #E7E7E7) !important;

`;


/**
 * Рамка с прозрачностью для низа
 */
export const ChooserOpacityBottom = styled(ChooserOpacity)`
    top: auto;
    bottom: 0;
      ${({ isFavoritesVersion }) => isFavoritesVersion && css`
        background: linear-gradient(to bottom, rgba(231, 231, 231, 0), rgba(231, 231, 231, 0.6) 12.39%, #E7E7E7) !important;
    `}
    background: ${(p) => p.theme.selectContextModal.opacityBottom};
    background: ${(p) => p.isRussianGalllleryStyle? 'linear-gradient(to bottom, rgba(231, 231, 231, 0), rgba(231, 231, 231, 0.6) 12.39%, rgba(231, 231, 231, 1))' : p.theme.selectContextModal.opacityBottom};
    ${({ disableOpacity }) => disableOpacity && css`
      background: transparent;
    `}
    ${({isFavoritesVersion})=> isFavoritesVersion && css`
        /* bottom: -1px; */
      `}
`;



export const FavoriteTitleContainer = styled.div`
  display: flex;
  flex-direction: column;
  row-gap: 12px;
  width: 100%;
  position: relative;
  z-index: 2000;
  background-color: ${Colors.galBlack10};
  padding: 16px 16px;
  `
export const FavoriteTitle = styled.div`
  font-family: Inter;
    font-size: 28px;
    font-style: normal;
    font-weight: 600;
    line-height: 34px; 
    letter-spacing: -0.56px;
    color: #212121;
`
export const FavoriteSubTitle = styled.div`
  font-family: Inter;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 16px;
  letter-spacing: -0.26px;
  color: #212121;
`
export const FavoriteIconCotainer = styled.div`
  display: flex
`